import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FilterIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

FilterIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FilterIcon);
